export const mapReferenceTypeToDisplay = (referenceType: string) => {
  const standardReferenceType = referenceType.replace(/-/g, "_");
  const referenceTypeToDisplay = {
    fuel_order: "fuel",
    order: "fuel",
    store_order: "store",
    ewallet_payment: "qr barcode",
    ewallet_payment_dynamic_qr: "qr barcode",
    pos_order: "pos",
    deal_order: "deal",
    opt_order: "opt",
    invenco_order: "checkout",
    pit_stop_order: "pit stop",
    concierge_order: "deliver2me",
    concierge_order_qsr: "deliver2me",
    vouchers: "vouchers",
    topup: "Top-up",
    invalid_reward: "invalid reward",
    checkout_session: "checkout",
    parking: "off street parking",
    on_street_parking: "on street parking",
    others: "others",
    motor_insurance: "insurance",
    ev_charging: "ev charging",
    season_parking: "season parking",
    static_qr_fuelling: "static qr fuelling",
    duit_now: "DuitNow",
  };
  const referenceTypeDisplay =
    referenceTypeToDisplay[standardReferenceType] || standardReferenceType;
  return referenceTypeDisplay?.replace(/_/g, " ");
};
